module.exports = __webpack_public_path__ + "img/3.1e2f5e02.svg";